/*
create EvOccMappingComponen standalone, hope this can be easily use in somewhere else
  notes : uses micro service data modal
          perhas need a util convert/mapping from micro to event form data model in the future use
*/

import {
    Component,
    ChangeDetectionStrategy,
    Input,
    ChangeDetectorRef,
    ViewEncapsulation,
    OnInit,
    Output,
    EventEmitter,
} from "@angular/core";
import { FormsModule } from "@angular/forms";

import { S25CheckboxModule } from "../modules/s25-checkbox/s25.checkbox.module";
import { S25Util } from "../util/s25-util";
import { PreferenceService } from "../services/preference.service";
import { Preference } from "../pojo/PeferenceI";

@Component({
    imports: [FormsModule, S25CheckboxModule],
    selector: "s25-calendar-settings",
    template: `@if (init) {
        <div class="c-margin-bottom--single c-margin-top--quarter">
            <p class="ngBold c-margin-bottom--quarter c-margin-top--single">Calendar Default Settings</p>
            <div>
                <s25-ng-checkbox
                    [(value)]="displayAdditionalTime"
                    (valueChange)="onChange($event, 'displayAdditionalTime')"
                    aria-label="Display Additional Time"
                    >Display Additional Time</s25-ng-checkbox
                >
            </div>
            <div>
                <s25-ng-checkbox
                    [(value)]="showBlackouts"
                    (valueChange)="onChange($event, 'showBlackouts')"
                    aria-label="Show Blackouts"
                    >Show Blackouts</s25-ng-checkbox
                >
            </div>
            <div>
                <s25-ng-checkbox
                    [(value)]="relatedLocations"
                    (valueChange)="onChange($event, 'relatedLocations')"
                    aria-label="Related Locations"
                    >Related Locations</s25-ng-checkbox
                >
            </div>
        </div>
    } `,
    styles: [``],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class S25CalendarSettingsComponent implements OnInit {
    @Input() type: Preference.PrefType = "S";
    @Output() modelValueChange = new EventEmitter<{ key: string; value: boolean }>();

    init: boolean = false;
    displayAdditionalTime: boolean = false;
    showBlackouts: boolean = false;
    relatedLocations: boolean = false;

    constructor(private cd: ChangeDetectorRef) {}

    async ngOnInit() {
        const prefs = await PreferenceService.getPreferences(
            ["DisplayAdditionalTime", "ShowBlackouts", "RelatedLocations"],
            this.type,
        );

        this.displayAdditionalTime = S25Util.toBool(prefs.DisplayAdditionalTime.value);
        this.showBlackouts = S25Util.toBool(prefs.ShowBlackouts?.value);
        this.relatedLocations = S25Util.toBool(prefs.RelatedLocations?.value);

        this.init = true;
        this.cd.detectChanges();
    }

    onChange($event: boolean, field: FieldI): void {
        this.modelValueChange.emit({ key: field, value: $event });
    }
}

export type FieldI = "displayAdditionalTime" | "showBlackouts" | "relatedLocations";
